import { AktivitetTemplate } from './GridAktiviteter';
import { Popup } from './Popup';
import { Utils } from '../Utils';
import * as moment from "moment";
import * as _ from "underscore";

export class EditAktivitet {
    popup: Popup;
    plan: any;
    nextAktId: number;
    form: DevExpress.ui.dxForm;
    brukere: any;
    allAktivitetsItem: any;
    aktivitet: AktivitetTemplate;
    refreshGrid: Function;
    noEdit: boolean;
    constructor(aktivitet: AktivitetTemplate, planId?: number, refresh?: Function, noEdit?: boolean) {
        let title = '';           
        this.noEdit = noEdit;
        const container = $("<div>");
        $("<div>").attr("id", "form").appendTo(container);
        $("<div style=\"height:1px; border-top:1px solid silver;margin-bottom:10px;\"/>").appendTo(container);
        const buttonContainer = $("<div>").css("float", "right");
        $("<div>").attr("id", "delete").appendTo(buttonContainer);
        $("<div>").attr("id", "kontrollere").appendTo(buttonContainer);
        $("<div>").attr("id", "cancel").appendTo(buttonContainer);
        $("<div>").attr("id", "ok").appendTo(buttonContainer);
        buttonContainer.appendTo(container);

        if (!aktivitet) {
            title = '<div class="p-header"><i class="fa fa-tasks"></i>Legg til ny hovedaktivitet...</div>';
            aktivitet = newEmptyAktivitet();
            aktivitet.planId = planId;
        } else {
            let type = aktivitet.hovedAktivitetId > 0 ? 'kopiaktivitet' : 'hovedaktivitet';
            title = '<div class="p-header"><i class="fa fa-tasks"></i>Edit ' + type  + ' nr. ' + aktivitet.id + '...</div>';
            if (aktivitet.forfall && aktivitet.forfall.toString() === "0001-01-01T00:00:00")
                aktivitet.forfall = null;
        }

        const popupOptions = {
            width: 800,
            height: 650 + Utils.addIE(15),
            contentTemplate: container,
            titleTemplate: title
        };
        this.aktivitet = aktivitet;
        this.popup = new Popup(popupOptions);
        this.createForm(aktivitet);
        this.refreshGrid = refresh;
    }

    createForm(aktivitet: AktivitetTemplate) {
        var self: EditAktivitet = this;
        Utils.wait("Henter data for aktivitet og CAB data...");
        $.get("/Data/GetPlan", { planId: aktivitet.planId }, (data) => {
            this.popup.show();
            self.plan = data.plan;
            self.nextAktId = data.nextAktId;
            self.brukere = data.brukere;

            if (aktivitet.aktId === "")
                aktivitet.aktId = data.nextAktId.toString();

            self.form = $("#form").dxForm({
                colCount: 2,
                formData: aktivitet,
                items: this.getFormOptions(aktivitet),
                onFieldDataChanged: () => {
                    $("#kontrollere").dxButton("option", { "disabled": true, "hint": "Kan ikke kontrollere endret aktivitet" });
                }
            }).dxForm("instance");

            Utils.setDatasource(self.form, "produksjonsTypeId", data.produksjonsType);
            Utils.setDatasource(self.form, "ordreTypeId", data.ordreType);
            Utils.setDatasource(self.form, "fakturaGruppeId", data.fakturaGruppe);
            Utils.setDatasource(self.form, "cabOrderNr", data.cabOrdre);
            Utils.setDatasource(self.form, "aktivitetsItemId", data.aktivitetsItem);
            self.allAktivitetsItem = data.aktivitetsItem;
            if (aktivitet.aktivitetsItem)
                this.filterAktivitet(aktivitet.aktivitetsItem.prosessId);

            this.setUpButtons();
            Utils.finished();
        });
    }

    setUpButtons() {
        var self: EditAktivitet = this;

        $("#btnKopiMerknad").dxButton({
            text: "Kopiere",
            icon: 'fa fa-copy',
            width: "95%",
            disabled: self.noEdit,
            onClick: (e) => {
                let id = self.form.option("formData").id;
                let merknader = self.form.option("formData").merknader;
                $.post("/Data/KopiMerknad", { id, merknader }, (result) => {
                    DevExpress.ui.notify("Har kopiert merknad til kopi aktiviteter!", "success", 2000);
                    //this.refreshGrid();
                });
            }
        });

        $("#kalkuleredatoer").dxButton({
            onClick: function () {
                //var startDate = self.form.option("formData").dato;
                let startDate = $("#datoProd").dxDateBox("instance").option('value');
                if (startDate === null) {
                    return;
                }
                var printfil = new Date(startDate);
                printfil.setDate(printfil.getDate() + 1);
                while (Utils.isInvalidDate(printfil))
                    printfil.setDate(printfil.getDate() + 1);
                self.form.updateData("printFil", printfil);

                var overfort = new Date(printfil.toString());
                overfort.setDate(overfort.getDate() + 1);
                while (Utils.isInvalidDate(overfort))
                    overfort.setDate(overfort.getDate() + 1);
                self.form.updateData("printFilOverfort", overfort);

                var distribute = new Date(overfort.toString());
                distribute.setDate(distribute.getDate() + 1);
                while (Utils.isInvalidDate(distribute))
                    distribute.setDate(distribute.getDate() + 1);
                self.form.updateData("distribusjon", distribute);

                var newdate = new Date(startDate);
                newdate.setDate(newdate.getDate() + self.plan.selskap.forfallDager);
                while (Utils.isInvalidDate(newdate))
                    newdate.setDate(newdate.getDate() + 1);
                self.form.updateData("forfall", newdate);
            },
            text: "Kalkulere",
            icon: 'fa fa-calculator',
            width: "98%",
            disabled: !this.aktivitet.erBatchJob || self.noEdit
        });

        $("#delete").dxButton({
                text: "Slett",
                type: "danger",
                height: 30,
                width: 150,
                icon: 'trash',
                disabled: self.noEdit,
                onClick: () => {
                    let container = $("<div>");
                    $("<div>").attr("id", "confirmation-no").appendTo(container);
                    $("<div>").attr("id", "confirmation-yes").appendTo(container);
                    let titleText = 'Er du sikker på at du vil slette kopiaktivitet?'
                    if (self.aktivitet.hovedAktivitetId <= 0)
                        titleText = "Er du sikker på at du vil slette hovedaktivitet og alle kopiaktiviteter?";
                    let popupContainer = $("<div>")
                        .attr("id", "confirmation")
                        .dxPopup({
                            height: 130,
                            width: 444,
                            contentTemplate: container,
                            title: "Er du sikker på at du vil slette aktivitet?",
                            showCloseButton: false,
                            dragEnabled: false,
                            titleTemplate: () => $("<div>")
                                .css({ "text-align": "center", "padding": "10px", "font-size": 18 })
                                .text(titleText)
                        });
                    popupContainer.appendTo($("body"));
                    let popup = popupContainer.dxPopup("instance");
                    popup.show();
                    $("#confirmation-yes").dxButton({
                        text: "Ja",
                        type: "success",
                        width: 200,
                        height: 30,
                        onClick: () => {
                            $.post("/Data/DeleteAktivitet", self.aktivitet)
                                .done(() => {
                                    DevExpress.ui.notify("Plan slettet!", "success", 2000);
                                    self.refreshGrid();
                                    self.popup.hide(); // Hide edit popup window
                                })
                                .fail(() => {
                                    DevExpress.ui.notify("Plan ikke slettet!", "error", 2000);
                                })
                                .always(() => {
                                    popupContainer.remove(); // Hide confirmation dialog
                                });
                        }
                    });
                    $("#confirmation-no").dxButton({
                        text: "Nei", type: "normal", width: 200, height: 30,
                        onClick: () => {
                            popupContainer.remove();
                        }
                    });
                }
        });

        $("#kontrollere").dxButton({
            text: this.aktivitet.kontrollertDato != null ? "Angre kontrollere aktivitet" : "Kontrollere aktivitet",
            height: 30,
            width: 200,
            icon: 'check',
            type: "default",
            disabled: self.aktivitet.id <= 0 || self.noEdit,
            //hint,
            onClick: () => {
                let url = self.aktivitet.kontrollertDato != null ? "/Data/KontrollereAktivitetFjerne" : "/Data/KontrollereAktivitet";
                $.post(url, self.aktivitet)
                    .done(() => {
                        DevExpress.ui.notify("Kontroll operasjon ferdig!", "success", 2000);
                        self.refreshGrid();
                        self.popup.hide();
                    })
                    .fail(() => {
                        DevExpress.ui.notify("Kontroll operasjon gikk ikke!", "error", 2000);
                    });
            }
        });

        $("#cancel").dxButton({
            text: "Lukk vindu", height: 30, width: 150, icon: 'close',
            onClick: () => {
                self.popup.hide();
            }
        });

        $("#ok").dxButton({
            text: "Lagre", type: "success", icon: 'save', height: 30, width: 150,
            disabled: self.noEdit,
            onClick: this.validateAktivitetTemplate.bind(self)
        });

        self.aktivitet.erBatchJob ? $("#txtForfall").show() : $("#txtForfall").hide();
    }

    getFormOptions(aktivitet: AktivitetTemplate): DevExpress.ui.dxFormGroupItem[] {
        const formOptions: any[] = [
            {
                itemType: "group",
                caption: "Info",
                items: this.infoItems()
            }, {
                itemType: "group",
                caption: "Datoer",
                items: this.datoItems()
            }, {
                itemType: "group",
                caption: "Aktivitet",
                items: this.aktivitetItems()
            }, {
                itemType: "group",
                caption: "Antall",
                items: this.ekstraInfoItems(aktivitet),
            }];
        return formOptions;
    }

    infoItems() {
        return [
            {
                dataField: 'aktId',
                label: { text: "Aktivitets Id" },
                editorOptions: { width: 100 },
                editorType: "dxTextBox"
            },
            {
                dataField: "erBatchJob",
                label: { text: "Er batch jobb?" },
                editorType: "dxCheckBox",
                editorOptions: {
                    onValueChanged: (e) => this.batchToggleDatoer(e.value)
                }
            }, {
                dataField: "produksjonsTypeId",
                label: { text: "Produksjons type" },
                editorType: "dxSelectBox",
                editorOptions: {
                    dataSource: [],
                    placeholder: "Søk her...",
                    valueExpr: "id",
                    displayExpr: "navn",
                    searchEnabled: true,
                    searchExpr: "navn",
                    searchMode: 'startswith'//, 
                    //onSelectionChanged: (e) => this.filterAktivitet(e.selectedItem.prosessId)
                },
                validationRules: [{
                    type: "required",
                    message: "Produksjons type er påkrevet"
                }]
            }, {
                dataField: "ordreTypeId",
                label: {
                    text: "Ordre type"
                },
                editorType: "dxSelectBox",
                editorOptions: {
                    dataSource: [],
                    placeholder: "Søk her",
                    valueExpr: "id",
                    displayExpr: "beskrivelse",
                    searchEnabled: true,
                    searchMode: 'startswith',
                    searchExpr: "beskrivelse",
                },
                validationRules: [{
                    type: "required",
                    message: "Ordre type er påkrevet"
                }]
            }, {
                dataField: "merknader",
                editorType: "dxTextArea",
                labelLocation: 'top',
                editorOptions: { 
                    height: 100
                },
                label: {
                    location: 'top'
                }
            },
            {
                label: {
                    text: "Kopi merknad til kopiaktiviteter"
                },
                template: $("<div id='btnKopiMerknad'/>")
            }
        ];
    }

    aktivitetItems() {
        var self: EditAktivitet = this;
        return [
            {
                itemType: "tabbed",
                colSpan: 1,
                cssClass: "tabPanelForm",
                tabPanelOptions: {
                    deferRendering: false
                },
                tabs: [
                    {
                        title: "Aktivitet",
                        colCount: 1,
                        width: "200px",
                        items: [
                            {
                                dataField: "aktivitetsItemId",
                                label: {
                                    text: "Aktivitet"
                                },
                                editorType: "dxSelectBox",
                                editorOptions: {
                                    dataSource: [],
                                    placeholder: "Søk her...",
                                    valueExpr: "id",
                                    displayExpr: (item) => {
                                        if (item === null)
                                            return;
                                        return item.navn + " - " + item.prosess.navn.substring(0, 2);
                                    },
                                    searchEnabled: true,
                                    searchMode: 'startswith',
                                    searchExpr: ["navn"],
                                    onOpened: (e) => {
                                        e.component._popup.option('width', 400);
                                    },
                                    onValueChanged: (e) => {
                                        console.log(e);
                                    }
                                },
                                validationRules: [{
                                    type: "required",
                                    message: "Aktivitet er påkrevet"
                                }]
                            },
                            {
                                dataField: "fakturaGruppeId",
                                label: {
                                    text: "Faktura gruppe"
                                },
                                editorType: "dxSelectBox",
                                editorOptions: {
                                    dataSource: [],
                                    placeholder: "Søk her...",
                                    valueExpr: "id",
                                    displayExpr: "navn",
                                    searchEnabled: true,
                                    searchMode: 'startswith',
                                    searchExpr: ["navn", "beskrivelse"],
                                }
                            }
                        ]
                    }, {
                        title: "CAB",
                        items: [{
                            dataField: 'cabOrderNr',
                            label: {
                                text: "CAB ordernummer"
                            },
                            editorType: "dxSelectBox",
                            editorOptions: {
                                dataSource: [],
                                placeholder: "Søk her...",
                                valueExpr: "nr",
                                displayExpr: (item) => {
                                    if (item === null)
                                        return;
                                    return item.nr + " - " + item.navn;
                                },
                                onValueChanged: (e) => {                                   
                                    if (e.value) {
                                        var data:any = (<any>self.form.getEditor("cabOrderNr")).option("dataSource");
                                        var order = _.find(data, (ord: any) => ord.nr === e.value);
                                        var batch = <any>self.form.getEditor("cabBatchId");
                                        batch.option("value", order.batchId);
                                    }
                                },
                                onOpened: function (e) {
                                    var popupInstance = e.element.find(".dx-popup").dxPopup("instance");
                                    popupInstance.option('width', 300);
                                },
                                searchEnabled: true,
                                searchMode: 'startswith',
                                searchExpr: ["nr"],
                            }
                        },
                        {
                            dataField: 'cabBatchId',
                            label: { text: "CAB batchnummer" },
                            editorType: "dxTextBox"
                        }]
                    },
                    {
                        title: "Utgår",
                        items: [{
                            dataField: 'utgaar',
                            label: { text: "Aktivitet utgår" },
                            editorType: "dxCheckBox",
                            editorOptions: {
                                onValueChanged: (e) => {
                                    if (e.value)
                                        self.kopiutgar();
                                }
                            }
                        }, {
                            dataField: 'erstattetAv',
                            label: { text: "Aktivitet er erstattet av" },
                            editorType: "dxTextBox"
                        }]
                    },
                    {
                        title: "Brukere",
                        items: [{
                            template: (data, itm) => {
                                let html = "<table>";
                                html += '<tr><td class="w110">Opprettet av:</td><td class="bold">' + Utils.fmtEmail(this.aktivitet.opprettetAv) + '</td><td class="pl-10">' + Utils.fmtDto(self.aktivitet.opprettetDato) + '</td></tr>';
                                html += '<tr><td class="w110">Sist endret av:</td><td class="bold">' + Utils.fmtEmail(this.aktivitet.sistEndretAv) + '</td><td class="pl-10">' + Utils.fmtDto(self.aktivitet.sistEndretDato) + '</td></tr>';
                                html += '<tr><td class="w110">Kontrollert av:</td><td class="bold">' + Utils.fmtEmail(this.aktivitet.kontrollertAv) + '</td><td class="pl-10">' + Utils.fmtDto(self.aktivitet.kontrollertDato) +  '</td></tr>';
                                html += '<tr><td class="w110">Kontrollert av drift:</td><td class="bold">' + Utils.fmtEmail(this.aktivitet.kontrollertAvDrift) + '</td><td class="pl-10">' + Utils.fmtDto(self.aktivitet.kontrollertDatoDrift) +  '</td></tr>';
                                html += '</table>';
                                itm.append(html);
                            }
                        }]
                    }]
            }];
    }

    datoItems() {
        var self: EditAktivitet = this;
        let aktivitet: AktivitetTemplate = this.aktivitet;
        let dateOptions: any = {
            width: "100%",
            min: this.plan.startDato,
            max: this.plan.sluttDato,
            showClearButton: true,
            disabled: !aktivitet.erBatchJob,
            onOpened: (e) => {
                Utils.colorDates();
                $(".dx-calendar-navigator .dx-button-content").click( () => {
                    Utils.colorDates();
                });
            }
        };
        let dateOptionsNoMax: any = {
            width: "100%",
            min: this.plan.startDato,
            showClearButton: true,
            disabled: !aktivitet.erBatchJob,
            isValid: true,
            onValueChanged: function (e) {
                if (e.value === "" || e.value === null || e.value === undefined) {
                    e.component.option("isValid", true);
                }
            },
            onOpened: (e) => {
                Utils.colorDates();
                $(".dx-calendar-navigator .dx-button-content").click(() => {
                    Utils.colorDates();
                });
            }
        };
        return [
            {
                template: (data, itm) => {
                    let html = '<table><tr>';
                    html += '<td style="width:133px">Produksjonsdato</td>';
                    html += '<td class="pl10"><div id="datoProd"/></td>';
                    html += '<td style="padding-left:28px;">Starttid:</td>';
                    html += '<td><div style="margin-left:5px;" id="edStarttid"/></div></td>';
                    html += '</tr></table>';
                    itm.append(html);
                    let ktid = aktivitet.starttidspunkt;
                    $("#edStarttid").dxTextBox({ height: 26, width: 43, value: ktid, disabled: false });
                    var options = _.assign({}, dateOptions);
                    options.value = new Date(aktivitet.dato ? aktivitet.dato.toString() : this.plan.startDato.toString()),
                    options.width = "110px";
                    options.disabled = false;
                    $("#datoProd").dxDateBox(options);
                },
                validationRules: [{
                    type: "required",
                    message: "Produksjonsdato er påkrevet"
                }, {
                    type: 'custom',
                    validationCallback(options) {
                        var start = this.noTime(this.plan.startDato);
                        var end = this.noTime(this.plan.sluttDato);
                        var selectedDate = this.noTime(new Date(options.value));
                        if (selectedDate.isBefore(start) || selectedDate.isAfter(end)) {
                            options.rule.message = "Produksjonsdato må være innenfor plan start og stop datoer.";
                            return false;
                        } else { return true; }
                    }
                }]
            },
            {
                label: {
                    text: "Kalkulere datoer"
                },
                template: (data, itm) => {
                    let html = '<div style="margin-left:-6px;">';
                    html += '<div id="kalkuleredatoer" />';
                    html += '</div>';
                    itm.append(html);
                }
            }, {
                dataField: "printFil",
                label: {
                    text: "Produksjon av printfil"
                },
                editorType: "dxDateBox",
                editorOptions: dateOptionsNoMax
            }, {
                dataField: "printFilOverfort",
                label: {
                    text: "Overs. til printleverandør"
                },
                editorType: "dxDateBox",
                editorOptions: dateOptionsNoMax
            }, {
                dataField: "distribusjon",
                label: {
                    text: "Distribusjons dato"
                },
                editorType: "dxDateBox",
                editorOptions: dateOptionsNoMax
            }, {
                dataField: "forfall",
                label: {
                    text: "Respons/Forfallsdato"
                },
                editorType: "dxDateBox",
                editorOptions: dateOptionsNoMax
            }, {
                label: {
                    text: "Forfallsdager for selskap"
                },
                template: (data, itm) => {
                    var html = $("<div id='txtForfall' class='tac'>" + this.plan.selskap.forfallDager + " dager</div>");
                    itm.append(html);
                }
            },
            {
                label: {
                    text: "Endringsordre:"
                },
                template: (data, itm) => {
                    let html = '<div style="margin-left:-6px;">';
                    html += '<div id="lageEndringsordre" />';
                    html += '</div>';
                    itm.append(html);
                    $("#lageEndringsordre").dxButton({
                        text: "Lage ny endringsordre",
                        icon: 'fa fa-clone',
                        type: "danger",
                        width: "98%",
                        disabled: self.plan.godkjentDato == null || self.noEdit,
                        onClick() {
                            if (self.aktivitet.hovedAktivitetId <= 0) {
                                self.endringsordre();
                            } else {
                                self.nyendringsordre(false);
                            }
                        }
                    });
                }
            }
        ];
    }

    ekstraInfoItems(aktivitet: AktivitetTemplate) {
        return [
            {
                template: (data, itm) => {
                    //debugger;
                    var html = '<table><tr>';
                    html += '<td style="width:110px">Antall planlagt</td>';
                    html += '<td>Privat</td><td class="pl10"><div id="edPlaP"/></td><td class="pl10">Næring</td><td class="pl10"><div id="edPlaN"/> </div></td>';
                    html += '</tr></table>';
                    itm.append(html);
                    $("#edPlaP").dxTextBox({ height: 26, width: 80, value: aktivitet.antallPlanlagt });
                    $("#edPlaN").dxTextBox({ height: 26, width: 80, value: aktivitet.antalPlanlagtNaering });
                }
            }, {
                template: (data, itm) => {
                    var html = '<table><tr>';
                    html += '<td style="width:110px">Antall produsert</td>';
                    html += '<td>Privat</td><td class="pl10"><div id="edProP"/></td><td class="pl10">Næring</td><td class="pl10"><div id="edProN"/> </div></td>';
                    html += '</tr></table>';
                    itm.append(html);
                    $("#edProP").dxTextBox({ height: 26, width: 80, value: aktivitet.antallProdusert });
                    $("#edProN").dxTextBox({ height: 26, width: 80, value: aktivitet.antalProdusertNaering });
                }
            }, {
                template: (data, itm) => {
                    var html = '<table><tr>';
                    html += '<td style="width:105px"><b>Avvik</b></td>';
                    html += '<td><b>Privat</b></td><td class="pl10"><div id="edAviP"/></td><td class="pl10"><b>Næring</b></td><td class="pl10"><div id="edAviN"/> </div></td>';
                    html += '</tr></table>';
                    itm.append(html);
                    $("#edAviP").dxTextBox({ height: 26, width: 80, disabled: true, value: aktivitet.antallPlanlagt - aktivitet.antallProdusert });
                    $("#edAviN").dxTextBox({ height: 26, width: 80, disabled: true, value: aktivitet.antalPlanlagtNaering - aktivitet.antalProdusertNaering });
                }
            }
        ];
    }

    filterAktivitet(prosessId) {
        if (!this.allAktivitetsItem) return;
        let editor = <any>this.form.getEditor("aktivitetsItemId");
        let filteredAktivitets = this.allAktivitetsItem.filter((item) => item.prosessId === prosessId);
        let currentAktivitet = editor.option("selectedItem")
        if (currentAktivitet && currentAktivitet.prosessId !== prosessId) {
            editor.option("value", null);
        }
        editor.option("dataSource", filteredAktivitets);
    }

    batchToggleDatoer(erBatchJob) {
        let fieldsToChange = ["printFil", "printFilOverfort", "distribusjon", "forfall"];
        for (let field of fieldsToChange) {
            let editor = <any>this.form.getEditor(field);
            if (editor) {
                if (erBatchJob) editor.option("value", null); // Change all values to null if changing from regular job to batch job
                editor.option("disabled", !erBatchJob);
            }
        }       
        $("#kalkuleredatoer").dxButton("option", "disabled", !erBatchJob);
        erBatchJob ? $("#txtForfall").show() : $("#txtForfall").hide();
    };

    validateAktivitetTemplate(params) {
        //debugger;
        var v1 = $("#edPlaP").dxTextBox("option", "text") * 1;
        var v2 = $("#edPlaN").dxTextBox("option", "text") * 1;
        var v3 = $("#edProP").dxTextBox("option", "text") * 1;
        var v4 = $("#edProN").dxTextBox("option", "text") * 1;
        this.form.updateData("antallPlanlagt", v1);
        this.form.updateData("antalPlanlagtNaering", v2);
        this.form.updateData("antallProdusert", v3);
        this.form.updateData("antalProdusertNaering", v4);

        var pd = $("#datoProd").dxDateBox("option", "value");
        this.form.updateData("dato", pd);

        var stid = $("#edStarttid").dxTextBox("option", "text");
        this.form.updateData("starttidspunkt", stid);

        var result: any = this.form.validate();
        if (result.isValid) {
            let akt = this.form.option("formData") as AktivitetTemplate;
            this.lagreAktivitet(akt);
            params.validationGroup.reset();
        } else {
            DevExpress.ui.notify("Venligst fill in all red fields before saving", "error", 2000);
        }
    }

    nyendringsordre(endreKopi: boolean) {
        var self: EditAktivitet = this;
        $.post('/Data/NyEndringsordre', { id: self.aktivitet.id, endreKopi: endreKopi }, (nyakt: AktivitetTemplate) => {
            self.popup.hide();
            self.refreshGrid();
            new EditAktivitet(nyakt, nyakt.planId, () => self.refreshGrid());
        });                
    }

    kopiutgar() {
        var self: EditAktivitet = this;
        let container = $("<div>");
        $("<div>").attr("id", "confirmation-no").appendTo(container);
        $("<div>").attr("id", "confirmation-yes").appendTo(container);
        let popupContainer = $("<div>")
            .attr("id", "confirmation")
            .dxPopup({
                height: 100,
                width: 444,
                contentTemplate: container,
                showCloseButton: false,
                dragEnabled: false,
                titleTemplate: () => $("<div>")
                    .css({ "text-align": "center", "padding": "10px", "font-size": 18 })
                    .text('Vil du også at alle kopiaktiviteter utgår?')
            });
        popupContainer.appendTo($("body"));
        let popup = popupContainer.dxPopup("instance");
        popup.show();
        $("#confirmation-yes").dxButton({
            text: "Ja", type: "success", width: 200, height: 30,
            onClick: () => {
                $.post('/Data/SetAlleKopiToUtgaar', { id: self.aktivitet.id }, (nyakt: AktivitetTemplate) => {
                    popupContainer.remove();
                    self.refreshGrid();
                });   
            }
        });
        $("#confirmation-no").dxButton({
            text: "Nei", type: "normal", width: 200, height: 30,
            onClick: () => popupContainer.remove()
        });           
    }

    endringsordre() {
        var self: EditAktivitet = this;
        let container = $("<div>");
        $("<div>").attr("id", "confirmation-no").appendTo(container);
        $("<div>").attr("id", "confirmation-yes").appendTo(container);
        let titleText = 'Vil du også lage endringsordre for kopiaktiviteter?';
        let popupContainer = $("<div>")
            .attr("id", "confirmation")
            .dxPopup({
                height: 100,
                width: 444,
                contentTemplate: container,
                title: "Kopiaktiviteter?",
                showCloseButton: false,
                dragEnabled: false,
                titleTemplate: () => $("<div>")
                    .css({ "text-align": "center", "padding": "10px", "font-size": 18 })
                    .text(titleText)
            });
        popupContainer.appendTo($("body"));
        let popup = popupContainer.dxPopup("instance");
        popup.show();
        $("#confirmation-yes").dxButton({
            text: "Ja",
            type: "success",
            width: 200,
            height: 30,
            onClick: () => {
                $.post('/Data/NyEndringsordre', { id: self.aktivitet.id, endreKopi: true }, (nyakt: AktivitetTemplate) => {
                    popupContainer.remove();
                    self.popup.hide();
                    self.refreshGrid();
                    new EditAktivitet(nyakt, nyakt.planId, () => self.refreshGrid());
                });     
            }
        });
        $("#confirmation-no").dxButton({
            text: "Nei", type: "normal", width: 200, height: 30,
            onClick: () => {
                popupContainer.remove();
                self.nyendringsordre(false);
            }
        });      
    }

    lagreAktivitet(aktivitet: AktivitetTemplate) {

        Utils.fixDates(aktivitet);
        var self = this;
        $.post("/Data/Aktivitet", { data: aktivitet })
            .done((success) => {
                DevExpress.ui.notify("Aktivitet er lagret !", "success", 2000);
                self.refreshGrid();
                self.popup.hide();
            })
            .fail((xhr, textStatus, errorThrown) => {
                DevExpress.ui.notify("Aktivitet er ikke lagret !", "error", 2000);
            });
    }

    noTime(dato: Date): any {
        return moment(dato).clone().hour(0).minute(0).second(0).millisecond(0)
    }

    getBruker(nr: number): string {
        for (let i = 0; i < this.brukere.length; i++) {
            if (this.brukere[i].id == nr)
                return this.brukere[i].navn;
        }
        return "";
    }
}

export function newEmptyAktivitet(): AktivitetTemplate {
    var aktTemplate: AktivitetTemplate = {
        id: null,
        aktId: "",
        dato: null,
        merknader: "",
        priority: 0,
        utgaar: false,
        erBatchJob: false,
        hovedAktivitetId: -1,
        planId: null,
        produksjonsTypeId: null,
        erstattetAv: -1,
        ordreTypeId: 1,
        aktivitetsItemId: null,
        fakturaGruppeId: null,
        orderId: 1,
        antallPlanlagt: 0,
        antallProdusert: 0,
        antalPlanlagtNaering: 0,
        antalProdusertNaering: 0,
        forfall: null,
        printFil: null,
        printFilOverfort: null,
        distribusjon: null,
        levert: null,
        opprettetAv: null,
        opprettetDato: null,
        sistEndretAv: null,
        sistEndretDato: null,
        kontrollertAv: 0,
        kontrollertDato: null,
        godKjenttAv: 0,
        godKjentDato: null,
        kontrollertAvDrift: 0,
        kontrollertDatoDrift: null,
        endringsAktivitetId: null,
        hasKopiAktivitet: false,
        aktivitetsItem: null,
        cabOrderNr: null,
        cabBatchId: null,
        starttidspunkt: null
    };
    return aktTemplate;
}


// WEBPACK FOOTER //
// ./TS/Plan/EditAktivitet.ts